import React from "react";
import PropTypes from "prop-types";

function OptionArrows({
  className,
  style,
  fill,
  stroke,
  defaultWidth,
  defaultHeight
}) {
  return (
    <svg
      viewBox="0 0 12 46"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.height ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path d="M.5-.5v48h16v-48H.5z" stroke={stroke} />
        <g fill={fill} fill-rule="nonzero">
          <path d="M8.407629 16.393691l3.389375 3.326273c.137328.132712.137328.34731 0 .480022l-.207453.20048c-.137328.132712-.35939.132712-.496719 0L8.15927 17.511861l-2.933563 2.885781c-.137328.132712-.35939.132712-.496719 0l-.207453-.20048c-.137328-.132712-.137328-.34731 0-.480022l3.389375-3.326272c.137328-.129889.35939-.129889.496719.002823zM7.910911 32.40011l-3.389375-3.326272c-.137328-.132712-.137328-.34731 0-.480022l.207453-.20048c.137328-.132712.35939-.132712.496719 0l2.933562 2.888605 2.933563-2.885781c.137328-.132712.35939-.132712.496719 0l.207453.20048c.137328.132712.137328.34731 0 .480022L8.40763 32.402934c-.137328.129889-.35939.129889-.496719-.002823z" />
        </g>
      </g>
    </svg>
  );
}

OptionArrows.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  tomoFill: PropTypes.string,
  creditFill: PropTypes.string
};

OptionArrows.defaultProps = {
  className: undefined,
  defaultHeight: 46,
  defaultWidth: 12,
  fill: "#99B5B7",
  stroke: "#99B5B7"
};

export default OptionArrows;
